import type { ComparisonPage, Competitor } from './types';

import { greyfield } from './competitors/greyfield';
import { sigma } from './competitors/sigma';
import { tableau } from './competitors/tableau';
import { omni } from './competitors/omni';
import { hex } from './competitors/hex';
import { metabase } from './competitors/metabase';
import { tripleWhale } from './competitors/triple-whale';
import { polar } from './competitors/polar';
import { lifetimely } from './competitors/lifetimely';
import { sellerboard } from './competitors/sellerboard';
import { beprofit } from './competitors/beprofit';
import { trueprofit } from './competitors/trueprofit';
import { supermetrics } from './competitors/supermetrics';
import { improvado } from './competitors/improvado';
import { northbeam } from './competitors/northbeam';
import { glew } from './competitors/glew';
import { saras } from './competitors/saras';
import { klar } from './competitors/klar';
import { windsor } from './competitors/windsor';
import { funnel } from './competitors/funnel';
import { powerbi } from './competitors/powerbi';
import { looker } from './competitors/looker';
import { peel } from './competitors/peel';
import { daasity } from './competitors/daasity';
import { shopifyAnalytics } from './competitors/shopify-analytics';

import { sigmaVsTableau } from './pages/sigma-vs-tableau';
import { sigmaVsOmni } from './pages/sigma-vs-omni';
import { sigmaVsHex } from './pages/sigma-vs-hex';
import { sigmaVsMetabase } from './pages/sigma-vs-metabase';
import { tripleWhaleVsWarehouse } from './pages/triple-whale-vs-custom-data-warehouse';
import { polarVsWarehouse } from './pages/polar-analytics-vs-custom-data-warehouse';
import { lifetimelyVsWarehouse } from './pages/lifetimely-vs-custom-data-warehouse';
import { sellerboardVsWarehouse } from './pages/sellerboard-vs-custom-data-warehouse';
import { beprofitVsWarehouse } from './pages/beprofit-vs-custom-data-warehouse';
import { trueprofitVsWarehouse } from './pages/trueprofit-vs-custom-data-warehouse';
import { supermetricsVsWarehouse } from './pages/supermetrics-vs-custom-data-warehouse';
import { improvadoVsWarehouse } from './pages/improvado-vs-custom-data-warehouse';
import { northbeamVsWarehouse } from './pages/northbeam-vs-custom-data-warehouse';
import { glewVsWarehouse } from './pages/glew-vs-custom-data-warehouse';
import { sarasVsWarehouse } from './pages/saras-analytics-vs-custom-data-warehouse';
import { klarVsWarehouse } from './pages/klar-vs-custom-data-warehouse';
import { windsorVsWarehouse } from './pages/windsor-vs-custom-data-warehouse';
import { funnelVsWarehouse } from './pages/funnel-vs-custom-data-warehouse';
import { sigmaVsPowerBi } from './pages/sigma-vs-power-bi';
import { sigmaVsLooker } from './pages/sigma-vs-looker';
import { peelVsWarehouse } from './pages/peel-vs-custom-data-warehouse';
import { daasityVsWarehouse } from './pages/daasity-vs-custom-data-warehouse';
import { shopifyAnalyticsVsWarehouse } from './pages/shopify-analytics-vs-custom-data-warehouse';

// Every competitor data file and every comparison page is registered here.
// Routing, the /compare hub, and the sitemap all read from these lists.

const competitorList: Competitor[] = [
  greyfield,
  sigma,
  tableau,
  omni,
  hex,
  metabase,
  tripleWhale,
  polar,
  lifetimely,
  sellerboard,
  beprofit,
  trueprofit,
  supermetrics,
  improvado,
  northbeam,
  glew,
  saras,
  klar,
  windsor,
  funnel,
  powerbi,
  looker,
  peel,
  daasity,
  shopifyAnalytics,
];

export const competitors: Record<string, Competitor> = Object.fromEntries(
  competitorList.map((competitor) => [competitor.id, competitor])
);

export const comparisons: ComparisonPage[] = [
  sigmaVsTableau,
  sigmaVsOmni,
  sigmaVsHex,
  sigmaVsMetabase,
  tripleWhaleVsWarehouse,
  polarVsWarehouse,
  lifetimelyVsWarehouse,
  sellerboardVsWarehouse,
  beprofitVsWarehouse,
  trueprofitVsWarehouse,
  supermetricsVsWarehouse,
  improvadoVsWarehouse,
  northbeamVsWarehouse,
  glewVsWarehouse,
  sarasVsWarehouse,
  klarVsWarehouse,
  windsorVsWarehouse,
  funnelVsWarehouse,
  sigmaVsPowerBi,
  sigmaVsLooker,
  peelVsWarehouse,
  daasityVsWarehouse,
  shopifyAnalyticsVsWarehouse,
];

export function getCompetitor(id: string): Competitor {
  const competitor = competitors[id];
  if (!competitor) throw new Error(`Unknown competitor: ${id}`);
  return competitor;
}

export function getComparison(slug: string): ComparisonPage | undefined {
  return comparisons.find((page) => page.slug === slug);
}
